// PrivateRoute.js - Componente per proteggere le route autenticate

import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * PrivateRoute - Wrapper per proteggere route che richiedono autenticazione
 * 
 * @param {boolean} isAuthenticated - Flag se l'utente è autenticato
 * @param {Array} allowedRoles - Array di ruoli autorizzati (opzionale)
 * @param {string} userRole - Ruolo dell'utente corrente (opzionale)
 * @param {ReactNode} children - Componente da renderizzare se autorizzato
 */


const PrivateRoute = ({ 
  isAuthenticated, 
  allowedRoles = null, 
  userRole = null, 
  children 
}) => {
  console.log('🔒 PrivateRoute check:', {
    isAuthenticated,
    allowedRoles,
    userRole,
    willCheckRoles: allowedRoles && allowedRoles.length > 0
  });
  // CHECK AUTENTICAZIONE
  if (!isAuthenticated) {
    console.log('❌ Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }
  // CHECK AUTORIZZAZIONE RUOLO
  if (allowedRoles && allowedRoles.length > 0) {
    console.log('🔍 Checking role authorization...');
    if (!userRole || !allowedRoles.includes(userRole)) {
      console.log('❌ Role not authorized:', { userRole, allowedRoles });
      return <Navigate to="/tools?error=forbidden" replace />;
    }
    console.log('✅ Role authorized');
  }
  console.log('✅ Access granted');
  return children;
};

export default PrivateRoute;